module.exports = __webpack_public_path__ + "static/img/wdhj1-4.7a5e0bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdhj1-4.png
// module id = 868
// module chunks = 0